<template>
  <div class="links">
    <ul class="ulLinks">
      <li id="primeiroLink" class="list-item clearfix">
        <a href="#" @click.prevent="handleClick('Especificacoes')" class="linksMenu">
          <div class="arrow">
            <i class="fa-solid fa-chevron-right"></i>
          </div>
          Especificações
        </a>
      </li>
      <div v-if="historico != null">
        <span class="faixa"></span>
        <li class="list-item">
          <a href="#" @click.prevent="handleClick('Historico')" class="linksMenu">
            <div class="arrow">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
            Historico
          </a>
        </li>
      </div>

      <span class="faixa"></span>
      <li v-if="dadosRest.length != 0" class="list-item">
        <span class="topico">Serviços REST</span>
      </li>
      <li v-for="(item, index) in dadosRest" :key="'rest' + index" class="list-item">
        <a href="#" class="linksMenu">
          <span @click.prevent="toggleSubMenu(item)">
            <div class="arrow" :class="{ rotated: isSubMenuOpen(item) }">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
            {{ item.descricao }}
          </span>
        </a>
        <ul v-show="isSubMenuOpen(item)" class="sub-menu clearfix">
          <li v-for="(subItem, subIndex) in item.listaSubMenu" :key="'restSub' + subIndex">
            <a href="#" class="linksMenu" @click.prevent="handleClick(subItem)">
              {{ subItem.descricao }}
            </a>
          </li>
        </ul>
        <span class="faixa-dinamica"></span>
      </li>
      

      <li v-if="dadosSoap.length != 0"  class="list-item">
        <span class="topico">Serviços SOAP</span>
      </li>
      <li v-for="(item, index) in dadosSoap" :key="'soap' + index" class="list-item">
        <a href="#" class="linksMenu">
          <span @click.prevent="toggleSubMenu(item)">
            <div class="arrow" :class="{ rotated: isSubMenuOpen(item) }">
              <i class="fa-solid fa-chevron-right"></i>
            </div>
            {{ item.descricao }}
          </span>
        </a>
        <ul v-show="isSubMenuOpen(item)" class="sub-menu clearfix">
          <li v-for="(subItem, subIndex) in item.listaSubMenu" :key="'soapSub' + subIndex">
            <a href="#" class="linksMenu" @click.prevent="handleClick(subItem)">
              {{ subItem.descricao }}
            </a>
          </li>
        </ul>
        <span class="faixa-dinamica"></span>
      </li>
    </ul>
  </div>  
</template>

<script>
import * as loaderUtils from '@/utils/loader';

export default {
  name: "Menu",
  props: {
    dadosApiMenu: {
      type: Array,
      default: () => []
    },
    grupo: String,
    nome: String,
    segmentacao: String,
    dadosApiCatalogo: Object
  },
  data() {
    return {
      dadosRest: [],
      dadosSoap: [],
      subMenusAbertos: [],
      historico: []
    };
  },
  methods: {
    async carregarDados() {
      this.historico = this.dadosApiCatalogo.historico;
      try {
        this.dadosRest = this.dadosApiMenu.filter(item => item.tipo === 'R');
        this.dadosSoap = this.dadosApiMenu.filter(item => item.tipo === 'S');
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    },
    toggleSubMenu(item) {
      const index = this.subMenusAbertos.indexOf(item);
      if (index > -1) {
        this.$delete(this.subMenusAbertos, index, item);
      } else {
        this.subMenusAbertos.push(item);
      }
    },
    isSubMenuOpen(item) {
      return this.subMenusAbertos.includes(item);
    },
    async handleClick(subItem) {
      loaderUtils.addLoarder();
      try {
        await this.carregarComponente(subItem);
      } finally {
        setTimeout(function(){
          loaderUtils.removeLoader();
        }, 500)
      }
    },
    carregarComponente(subItem) {
      return new Promise((resolve) => {
        if (subItem === "Especificacoes") {
          this.$emit("alterar-componente", "Especificacoes", "");
        } else if (subItem === "Historico") {
          this.$emit("alterar-componente", "Historico", "");
        } else  {
          this.$emit("alterar-componente", "Documentacao", subItem.idServicoApi);
        }
        resolve();
      });
    }
  },
  watch: {
    dadosApiMenu: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.carregarDados();
        } else {
          console.warn("Novos dados recebidos em dadosApiMenu são undefined ou vazios.");
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.carregarDados();
  },
};
</script>
